<template>
	<div id="interview" class="pt-14 pb-13 py-sm-16">
		<h2 class="sub--title mb-1" v-html="$t('interview.sub-title')"></h2>
		<h1 class="main--title mb-10 mb-sm-11" v-html="$t('interview.title')"></h1>

		<div class="mb-7 mb-sm-12 px-4" style="overflow-x: auto">
			<div
				v-if="language === 'ko'"
				style="width: 545px"
				class="mx-auto d-flex align-center justify-start justify-sm-center"
			>
				<div
					class="point"
					:class="{ active: active === 1 }"
					@click="active = 1"
				>
					{{ $t('interview.point-1') }}
				</div>
				<div
					class="point"
					:class="{ active: active === 2 }"
					@click="active = 2"
				>
					{{ $t('interview.point-2') }}
				</div>
				<div
					class="point"
					:class="{ active: active === 3 }"
					@click="active = 3"
				>
					{{ $t('interview.point-3') }}
				</div>
				<div
					class="point"
					:class="{ active: active === 4 }"
					@click="active = 4"
				>
					{{ $t('interview.point-4') }}
				</div>
			</div>
		</div>
		<div
			style="max-width: 900px"
			class="mb-11 mx-auto px-4 d-sm-flex align-center"
		>
			<!-- <v-img
				src="@/assets/images/interview-preview@2x.png"
				max-width="505"
				
			></v-img> -->
			<div class="interview-preview">
				<div v-html="embededVideo" class="ifram-wrap"></div>
			</div>
			<div class="py-6 py-sm-0 px-4 px-sm-0 interview-card">
				<h2 class="content-sub--title mb-2">{{ activeInterview.subTitle }}</h2>
				<h1 class="content--title mb-2 mb-sm-7 white-space-pre">
					{{ activeInterview.title }}
				</h1>
				<p class="content mb-4 white-space-pre">
					{{ activeInterview.comment }}
				</p>
				<div class="content-tag d-flex align-center">
					{{ activeInterview.job }}
					<div class="dot"></div>
					{{ activeInterview.name }}
				</div>
				<div class="content-tag d-flex align-center">
					{{ activeInterview.years }}
				</div>
			</div>
		</div>

		<v-row no-gutters class="mx-auto" style="max-width: 870px">
			<v-col cols="12" sm="4" class="px-2 mb-3 mb-sm-0">
				<div class="card text-center pt-5 pb-6">
					<v-img
						class="mx-auto mb-3"
						:width="language === 'ja' ? 120 : 81"
						src="@/assets/images/crown.png"
					>
						<p
							:class="{ 'pt-3': language === 'ko', 'pt-5': language === 'ja' }"
						>
							{{ $t('interview.crown-1', { count: '398,214' }) }}
						</p>
					</v-img>
					<div class="count" v-html="$t('interview.crown-1.data')"></div>
				</div>
			</v-col>
			<v-col cols="12" sm="4" class="px-2 mb-3 mb-sm-0">
				<div class="card text-center pt-5 pb-6">
					<v-img
						class="mx-auto mb-3"
						:width="language === 'ja' ? 120 : 81"
						src="@/assets/images/crown.png"
					>
						<p
							:class="{ 'pt-3': language === 'ko', 'pt-5': language === 'ja' }"
						>
							{{ $t('interview.crown-2', { count: '147,167' }) }}
						</p>
					</v-img>
					<div class="count" v-html="$t('interview.crown-2.data')"></div>
				</div>
			</v-col>
			<v-col cols="12" sm="4" class="px-2 mb-3 mb-sm-0">
				<div class="card text-center pt-5 pb-6">
					<v-img
						class="mx-auto mb-3"
						:width="language === 'ja' ? 120 : 81"
						src="@/assets/images/crown.png"
					>
						<p
							:class="{ 'pt-3': language === 'ko', 'pt-5': language === 'ja' }"
						>
							{{ $t('interview.crown-3') }}
						</p>
					</v-img>
					<div class="count">4.8/5.0</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 1,
			interview: [
				{
					subTitle: this.$t('interview.interview-1.sub-title'),
					title: this.$t('interview.interview-1.title'),
					comment: this.$t('interview.interview-1.comment'),
					job: this.$t('interview.interview-1.job'),
					name: this.$t('interview.interview-1.name'),
					years: this.$t('interview.interview-1.years'),
				},
				{
					subTitle: this.$t('interview.interview-2.sub-title'),
					title: this.$t('interview.interview-2.title'),
					comment: this.$t('interview.interview-2.comment'),
					job: this.$t('interview.interview-2.job'),
					name: this.$t('interview.interview-2.name'),
					years: this.$t('interview.interview-2.years'),
				},
				{
					subTitle: this.$t('interview.interview-3.sub-title'),
					title: this.$t('interview.interview-3.title'),
					comment: this.$t('interview.interview-3.comment'),
					job: this.$t('interview.interview-3.job'),
					name: this.$t('interview.interview-3.name'),
					years: this.$t('interview.interview-3.years'),
				},
				{
					subTitle: this.$t('interview.interview-4.sub-title'),
					title: this.$t('interview.interview-4.title'),
					comment: this.$t('interview.interview-4.comment'),
					job: this.$t('interview.interview-4.job'),
					name: this.$t('interview.interview-4.name'),
					years: this.$t('interview.interview-4.years'),
				},
			],
		}
	},
	computed: {
		activeInterview() {
			return this.interview[this.active - 1]
		},
		language() {
			return this.$store.getters['language']
		},
		userDevice() {
			return this.$store.getters['userDevice']
		},
		embededVideo() {
			let code = ''
			switch (this.active) {
				case 1:
					code =
						this.userDevice === 'desktop'
							? this.language === 'ko'
								? `<iframe width="505" height="285" src="https://www.youtube.com/embed/rD63giXRV84" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
								: `<iframe src="https://player.vimeo.com/video/585615328?h=c059116435&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="505" height="285" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Tella_利用後記①_ヘジンさん"></iframe>`
							: this.language === 'ko'
							? `<iframe width="335" height="202" src="https://www.youtube.com/embed/rD63giXRV84" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
							: `<iframe src="https://player.vimeo.com/video/585615328?h=c059116435&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="335" height="202" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Tella_利用後記①_ヘジンさん"></iframe>`
					break
				case 2:
					code =
						this.userDevice === 'desktop'
							? `<iframe width="505" height="285" src="https://www.youtube.com/embed/8Jg4rSSnhLU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
							: `<iframe width="335" height="202" src="https://www.youtube.com/embed/8Jg4rSSnhLU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
					break
				case 3:
					code =
						this.userDevice === 'desktop'
							? `<iframe width="505" height="285" src="https://www.youtube.com/embed/Js2TbTPIkXo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
							: `<iframe width="335" height="202" src="https://www.youtube.com/embed/Js2TbTPIkXo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
					break
				case 4:
					code =
						this.userDevice === 'desktop'
							? `<iframe width="505" height="285" src="https://www.youtube.com/embed/U5yWdRYAHaY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
							: `<iframe width="335" height="202" src="https://www.youtube.com/embed/U5yWdRYAHaY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
					break
			}
			return code
		},
	},
}
</script>

<style lang="scss" scoped>
.sub--title {
	font-size: 18px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.9px;
	text-align: center;
	color: #2168ff;
}
.main--title {
	font-size: 30px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -1.5px;
	text-align: center;
	color: #1a1a1a;
}
.point {
	min-width: 120px;
	margin-right: 8px;
	padding: 11px 15px 11px 16px;
	border-radius: 24px;
	background-color: #fff;
	border: solid 2px #dedede;
	font-size: 16px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.8px;
	text-align: center;
	color: #808080;
}
.point.active {
	border-color: #1669ff;
	color: #1669ff;
	font-weight: bold;
}

.interview-card {
	width: 310px;
}

@media screen and (max-width: 600px) {
	.interview-card {
		width: 335px;
		margin: 0 auto;
		border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px;
		box-shadow: 0 10px 30px 0 rgba(33, 51, 82, 0.1);
	}
}

.content-sub--title {
	font-size: 14px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -1px;
	color: #116dff;
}
.content--title {
	font-size: 20px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -1px;
	color: #000;
}
.content {
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.71;
	letter-spacing: -0.7px;
	color: #1a1a1a;
}
.content-tag {
	font-size: 12px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.67;
	letter-spacing: -0.6px;
	color: #666;
}
.dot {
	margin: 0 3px;
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background-color: #4b4b4b;
}

.card {
	border-radius: 15px;
	background-color: #f5f5f5;
	p {
		margin-bottom: 0;
		font-size: 14px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: -1px;
		text-align: center;
		color: #116dff;
	}
}

.count {
	font-size: 33px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
	color: #1a1a1a;
	span {
		font-size: 20px;
		color: #888;
	}
}

.ifram-wrap {
	width: 505px;
	height: 285px;
	border-radius: 20px;
	overflow: hidden;
}

@media screen and (max-width: 600px) {
	.ifram-wrap {
		width: 337px;
		padding: 1px 1px 1px 0px;
		height: 203px;
		margin: 0 auto;
		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 0px;
	}
}

.interview-preview {
	width: calc(100% - 310px);
	border-radius: 20px;
}

@media screen and (max-width: 600px) {
	.interview-preview {
		width: 335px;
		margin: 0 auto;
		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 0px;
	}
}
</style>

<style lang="scss">
#interview {
	.count {
		span {
			font-size: 20px;
			color: #888;
		}
	}
}
</style>
